// extracted by mini-css-extract-plugin
export default {"wrapper":"CommentCardPreview_wrapper__Hpiq8","content":"CommentCardPreview_content__OtzJR"};